import { autoinject } from 'aurelia-dependency-injection';
import { TokenService } from './TokenService';
import { ICompany } from '../framework/PortalFramework';

export class NavServiceConfig {
  public logoutUrl = '/#logout';
  public apiBaseUrl: string;
  public homeLocalOverrideUrl?: string;
  public logoApiBaseUrl?: string;

  constructor(config: Partial<NavServiceConfig>) {
    Object.assign(this, config);
    this.apiBaseUrl = config.apiBaseUrl + '/api'; // WARNING: apiBaseUrl in nav is different
  }
}

// This class only exists for devs to override nav during local development
// It's value is set in development.tsx
export class NavOverride {
  public navigationId: string;
  public mediaType: string;
  public url: string;

  constructor(navOverride: Partial<NavOverride> = {}) {
    Object.assign(this, navOverride);
  }
}

@autoinject
export class NavService {
  constructor(private config: NavServiceConfig, private tokenService: TokenService, private navOverride: NavOverride) { }

  mount(): Promise<{ company: ICompany }> {
    const { logoutUrl, apiBaseUrl } = this.config;
    const accessToken = this.tokenService.getAccessToken();

    return (window as any).SmartOfficeNavigation.mount({
      logoutUrl,
      mountElement: document.querySelector('#common-navigation'),
      apiBaseUrl: apiBaseUrl,
      accessToken,
      identityToken: accessToken, // TODO: Replace with real idToken when adopted by auth flow
      navLocalOverride: this.navOverride.navigationId ? this.navOverride : undefined,

      // this is here for backwards compatibility until the latest SON jS releases
      homeLocalOverrideUrl: this.config.homeLocalOverrideUrl,
      overrides: {
        homeUrl: this.config.homeLocalOverrideUrl,
        logoApiBaseUrl: this.config.logoApiBaseUrl
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/support/NavService.ts